export const COMMAND_PATH = "/cmd";

/**
 * Without this the server reports failures as plain text with its own error
 * grammar; with it, every failure is HTTP 200 plus ErrorCode / ErrorMessage.
 */
export const RESULT_AS_JSON_QUERY = "resultAsJson=true";

export const JSON_CONTENT_TYPE = "application/json; charset=UTF-8";

/** A body signed with КЕП travels as opaque bytes, not as JSON. */
export const SIGNED_CONTENT_TYPE = "application/octet-stream";

/** The server answers 204 when the query was valid and the data does not exist. */
export const NO_CONTENT_STATUS = 204;

export const OK_STATUS = 200;

/** ErrorCode 0 is success even when the field is present. */
export const ERROR_CODE_OK = 0;

/** ErrorCode 13: requested data absent — the JSON twin of HTTP 204. */
export const ERROR_CODE_NO_CONTENT = 13;

/** Documents are the seller's original XML: parseable without a CMS unwrap. */
export const DOCUMENT_REQUEST_ORIGINAL_XML = 1;
